/** Message animation — controlled from the Design tab only. */

export const MESSAGE_ANIMATION_TYPES = {
  TICKER_RTL: "ticker_rtl",
  SHIMMER_SWEEP: "shimmer_sweep",
  PULSE_SOFT: "pulse_soft",
  FLOAT_BOUNCE: "float_bounce",
};

export const ANIMATION_TYPE_OPTIONS = [
  { label: "News ticker (right to left)", value: MESSAGE_ANIMATION_TYPES.TICKER_RTL },
  { label: "Shimmer sweep", value: MESSAGE_ANIMATION_TYPES.SHIMMER_SWEEP },
  { label: "Pulse urgency", value: MESSAGE_ANIMATION_TYPES.PULSE_SOFT },
  { label: "Bounce friendly", value: MESSAGE_ANIMATION_TYPES.FLOAT_BOUNCE },
];

const DEFAULT_DURATION = {
  [MESSAGE_ANIMATION_TYPES.TICKER_RTL]: 18,
  [MESSAGE_ANIMATION_TYPES.SHIMMER_SWEEP]: 2.8,
  [MESSAGE_ANIMATION_TYPES.PULSE_SOFT]: 2,
  [MESSAGE_ANIMATION_TYPES.FLOAT_BOUNCE]: 2.5,
};

export const TICKER_DURATION_MIN = 6;
export const TICKER_DURATION_MAX = 45;
export const TICKER_DURATION_DEFAULT = 18;

/** True only when the merchant explicitly enabled animation in Design. */
export function isMessageAnimationEnabled(design) {
  const anim = design?.message_animation;
  if (!anim || typeof anim !== "object") return false;
  if (anim.enabled === false) return false;
  if (anim.enabled === true) return !!anim.type;
  // Legacy saved bars: had type but no enabled flag
  return !!anim.type;
}

export function resolveMessageAnimation(design) {
  if (!isMessageAnimationEnabled(design)) return null;
  return design.message_animation;
}

export function hasAnimatedMessage(design) {
  return !!resolveMessageAnimation(design)?.type;
}

export function isTickerAnimation(design) {
  return resolveMessageAnimation(design)?.type === MESSAGE_ANIMATION_TYPES.TICKER_RTL;
}

export function animationDurationSec(design) {
  const anim = resolveMessageAnimation(design);
  const fallback = DEFAULT_DURATION[anim?.type] ?? 2;
  const sec = Number(anim?.duration_sec);
  return Number.isFinite(sec) && sec > 0 ? sec : fallback;
}

export function defaultDurationForType(type) {
  return DEFAULT_DURATION[type] ?? TICKER_DURATION_DEFAULT;
}

/** @deprecated use animationDurationSec */
export function tickerDurationSec(design) {
  return animationDurationSec(design);
}

/** @deprecated use hasAnimatedMessage */
export function isTickerMessage(design) {
  return isTickerAnimation(design);
}
